import type { StoneSpecification } from '@/features/pdp/domain/models/ProductDetail';
import { formatStoneSpecSize } from '@/features/pdp/utils/productDetailStones';

interface PdpDesktopStoneSpecTableProps {
  specs: StoneSpecification[];
  hideSizeRow?: boolean;
}

interface SpecRow {
  label: string;
  values: Array<string | number | null>;
}

function buildSpecRows(specs: StoneSpecification[], hideSizeRow: boolean): SpecRow[] {
  const rows: SpecRow[] = [
    { label: 'Count', values: specs.map((spec) => spec.count) },
    { label: 'Shape', values: specs.map((spec) => spec.shape) },
    ...(hideSizeRow
      ? []
      : [{ label: 'Size', values: specs.map((spec) => formatStoneSpecSize(spec)) }]),
    { label: 'Setting Type', values: specs.map((spec) => spec.settingType) },
  ];

  return rows.filter((row) => row.values.some((value) => value != null && value !== ''));
}

export function PdpDesktopStoneSpecTable({
  specs,
  hideSizeRow = false,
}: PdpDesktopStoneSpecTableProps) {
  if (specs.length === 0) return null;

  const rows = buildSpecRows(specs, hideSizeRow);
  if (rows.length === 0) return null;

  return (
    <>
      {rows.map((row) => (
        <div
          key={row.label}
          className="flex items-center border-t border-[#eee] px-4 py-2.5 text-xs text-[#5b7da3]"
        >
          <div className="w-[120px] shrink-0">{row.label}</div>
          <div
            className="grid min-w-0 flex-1"
            style={{ gridTemplateColumns: `repeat(${specs.length}, minmax(0, 1fr))` }}
          >
            {row.values.map((value, index) => (
              <div key={`${row.label}-${index}`} className="px-1 text-right">
                {value ?? ''}
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
